import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PropertiesConstants from "@components/common/constants/PropertiesConstants";
import ThemeComponents from "@components/common/funtion/ThemeFunctions/ThemeComponents";
import { BeoIcon } from "@components/common/view";
import { getUserName } from "@utils/auth";
import { Menu } from "primereact/menu";
import { Sidebar } from "primereact/sidebar";
import { useRef, useState } from "react";
var CommonHeader = function (_a) {
    var handleLogout = _a.handleLogout;
    var userMenu = useRef(null); // Ref for user popup menu
    var localizedConstants = PropertiesConstants();
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    return (_jsxs(_Fragment, { children: [_jsx(Sidebar, { visible: visible, position: "right", onHide: function () { return setVisible(false); }, className: "w-full md:w-80 lg:w-96", children: _jsx("div", { className: visible ? "block" : "hidden", children: _jsx(ThemeComponents, {}) }) }), _jsxs("div", { className: "flex items-center gap-2 rounded-full border border-[var(--primary-color)]   bg-white/90 shadow-sm hover:bg-white cursor-pointer fixed top-0 right-2 z-50 \n          items-right p-1 space-x-1 transition duration-300 ease-in-out hover:scale-105 hover:shadow-lg\n          backdrop-blur-md animate-fade-in-left ", onClick: function (e) { var _a; return (_a = userMenu.current) === null || _a === void 0 ? void 0 : _a.toggle(e); }, children: [_jsx("div", { className: "flex items-center justify-center dark:bg-gray-600 border border-[var(--primary-color)] text-[var(--primary-color)] rounded-full w-8 h-8", children: _jsx(BeoIcon, { id: "user", className: "pi pi-user text-base" }) }), _jsx("span", { className: "text-sm font-medium text-gray-800 p-1", children: getUserName() || "User" })] }), _jsx(Menu, { model: [
                    // {
                    //   label: localizedConstants.menu.profile,
                    //   icon: "pi pi-user",
                    //   command: () => {},
                    // },
                    {
                        label: localizedConstants.menu.settings,
                        icon: "pi pi-cog animate-spin",
                        command: function () { return setVisible(true); },
                    },
                    { separator: true },
                    {
                        label: localizedConstants.menu.logout,
                        icon: "pi pi-sign-out text-red-500",
                        command: handleLogout,
                    },
                ], popup: true, ref: userMenu, className: "w-48" })] }));
};
export default CommonHeader;
